import { Route } from "react-router-dom";
import WorkerSnapshot from "../components";
import WorkerBotForm from "../components/index_bot";
import WorkerSnapshotbot from "../components/index_snapshot";
import WorkerCompliancebot from "../components/index_compliance";
// import WorkerBenefitsStabilityBot from "../components/index_benefit_stability";
import FreePilotRegistration from "../components/free_pilot_registration";

const WorkerSnapshotRoutes = () => (
  <>
    <Route path="/worker-snapshot" element={<WorkerSnapshot />} />
    <Route path="/worker-bot" element={<WorkerBotForm />} />
    <Route path="/readiness-compliance-assistant" element={<WorkerSnapshotbot />} />
    <Route path="/state-resource-guide" element={<WorkerCompliancebot />} />
    {/* <Route path="/benefits-stability-assistant" element={<WorkerBenefitsStabilityBot />} /> */}
    <Route path="/free-pilot-registration" element={<FreePilotRegistration />} />
  </>
);


export default WorkerSnapshotRoutes;